import { Injectable } from '@angular/core';
import { AgeRate, AgeRateFilterAbstractService } from 'osn-shared';
import { Observable, of } from 'rxjs';

@Injectable()
export class AgeRateFilterService extends AgeRateFilterAbstractService {
  public hasValidProfileState$: Observable<boolean> = of(true);
  public allParentalRating$: Observable<AgeRate[]> = of([]);
}
